module.exports = __webpack_public_path__ + "static/media/home-chargers.b0aad2f6.svg";